import React from "react";
import { Chip } from "@my-scoot/component-library-legacy";
import styles from "./ExpiredStatus.module.css";

const ExpiredStatus = () => {
  return <Chip chipClassName={styles.root} label="Expired" />;
};

export default ExpiredStatus;
